<div class="ch-panel-content-wrapper">
  <div class="ch-panel-content-scrollable-wrapper scrollbars">
    <div class="files-list">
      <div class="file-items">
        <div *ngIf="clientsFiles">
          <h4 class="recent-files-subtitle" *ngIf="clientsFiles.length > 0">
            From Client
          </h4>
          <div
            *ngFor="let file of clientsFiles; let i = index"
            [ngClass]="{ selected: selectedRecentFileIndex === i + 1 }"
            class="file-item selected"
            title="{{ file.filename }}"
            style="width: 100%"
          >
            <div
              [href]="file.url"
              filePreview
              [type]="file.ext"
              [etag]="file.etag"
              [file]="file"
              style="display: flex; justify-content: space-between; width: 100%"
            >
              <div
                class="file-icon file-{{ file.ext }}"
                [style.background-image]="'url(' + file.url + ')'"
              ></div>
              <div class="file-name" style="max-width: 70%">
                {{ file.filename }}
              </div>
              <div class="file-info">
                {{
                  file.upload_date
                    | amFromUtc
                    | amLocal
                    | amCalendar: moment_calendar_format
                }}
              </div>
            </div>

            <div>
              <div class="file-dropdown">
                <span class="dropdown" dropdown [autoClose]="true">
                  <span
                    id="dLabel"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    dropdownToggle
                  >
                    <div class="feather more-horizontal"></div>
                  </span>
                  <ul
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dLabel"
                    *dropdownMenu
                  >
                    <li
                      (click)="
                        openRenameModal(renameModal, file.filename, file.etag)
                      "
                    >
                      <a><i class="feather edit-3"></i> Rename</a>
                    </li>
                    <li (click)="openModalMoveFile(file.filename, file.etag)">
                      <a
                        ><i class="feather corner-up-left"></i> Save in
                        Folder</a
                      >
                    </li>
                    <li class="divider"></li>
                    <li
                      (click)="
                        openDeleteConfirmationModal(file.filename, file.etag)
                      "
                    >
                      <a><i class="feather trash-2"></i> Delete</a>
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="staffsFiles">
          <h4 class="recent-files-subtitle" *ngIf="staffsFiles.length > 0">
            From Staff
          </h4>
          <div
            *ngFor="let file of staffsFiles; let i = index"
            [ngClass]="{ selected: selectedRecentFileIndex === i + 1 }"
            class="file-item selected"
            title="{{ file.filename }}"
            style="width: 100%"
          >
            <div
              [href]="file.url"
              filePreview
              [type]="file.ext"
              [etag]="file.etag"
              [file]="file"
              style="display: flex; justify-content: space-between; width: 100%"
            >
              <div
                class="file-icon file-{{ file.ext }}"
                [style.background-image]="'url(' + file.url + ')'"
              ></div>
              <div class="file-name" style="max-width: 70%">
                {{ file.filename }}
              </div>
              <div class="file-info">
                {{
                  file.upload_date
                    | amFromUtc
                    | amLocal
                    | amCalendar: moment_calendar_format
                }}
              </div>
            </div>

            <div>
              <div class="file-dropdown">
                <span class="dropdown" dropdown [autoClose]="true">
                  <span
                    id="dLabel"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    dropdownToggle
                  >
                    <div class="feather more-horizontal"></div>
                  </span>
                  <ul
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dLabel"
                    *dropdownMenu
                  >
                    <li
                      (click)="
                        openRenameModal(renameModal, file.filename, file.etag)
                      "
                    >
                      <a><i class="feather edit-3"></i> Rename</a>
                    </li>
                    <li (click)="openModalMoveFile(file.filename, file.etag)">
                      <a
                        ><i class="feather corner-up-left"></i> Save in
                        Folder</a
                      >
                    </li>
                    <li class="divider"></li>
                    <li
                      (click)="
                        openDeleteConfirmationModal(file.filename, file.etag)
                      "
                    >
                      <a><i class="feather trash-2"></i> Delete</a>
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- rename modal -->
    <ng-template #renameModal>
      <div class="modal-header text-center" style="border-bottom: none">
        <!-- <i class="feather check-circle x3" style="color: #0084ff;"></i> -->
        <h4>Rename</h4>
        <p>
          Type in the new name for file
          <strong>{{
            selectedFile?.filename.substring(
              0,
              selectedFile.filename.lastIndexOf(".")
            )
          }}</strong
          >.<br />
        </p>
        <input
          #txtNewName
          type="text"
          class="form-control rename-file-input"
          style="text-align: center; font-weight: 600"
          value=""
        />
      </div>
      <div class="modal-footer">
        <div
          class="btn btn-default pull-left"
          aria-label="Cancel"
          (click)="bsModalRef.hide()"
        >
          Cancel
        </div>
        <div
          class="btn btn-primary pull-right"
          (click)="renameFile(txtNewName.value, selectedFile.etag)"
        >
          Rename
        </div>
      </div>
    </ng-template>
  </div>
</div>
